import { createSelector } from 'reselect';
import {
  getOneXpExperiments,
  hasOneXpRequestFinished
} from 'src/universal/redux/oneXp';
import {
  getExperimentalPageData,
  getPageFirstCardData,
  getActivePageName
} from 'src/universal/redux/page';

export const isG170MobileA = createSelector(
  [getOneXpExperiments, hasOneXpRequestFinished],
  (oneXpExperiments, oneXpDecided) => {
    return (
      oneXpExperiments['GCS-170-PDP-Filmstrip-Mobile']?.dimensions[0]?.variant ===
        'variant-a' && oneXpDecided
    );
  }
);

export const isG170MobileB = createSelector(
  [getOneXpExperiments, hasOneXpRequestFinished, getActivePageName],
  (oneXpExperiments, oneXpDecided, activePageName) => {
    return (
      oneXpExperiments['GCS-170-PDP-Filmstrip-Mobile']?.dimensions[0]?.variant ===
        'variant-b' &&
      oneXpDecided &&
      activePageName === 'businessPDP'
    );
  }
);

export const isG170DesktopVariant = createSelector(
  [getOneXpExperiments, hasOneXpRequestFinished],
  (oneXpExperiments, oneXpDecided) => {
    return (
      oneXpExperiments['GCS-170-PDP-Filmstrip-Desktop']?.dimensions[0]?.variant ===
        'variant' && oneXpDecided
    );
  }
);

export const getG170CombinedData = createSelector(
  [isG170DesktopVariant, getExperimentalPageData, getPageFirstCardData],
  (isG170Desktop, { g170SubnavData }, currCard) => {
    return {
      isG170Desktop,
      g170StaticData: g170SubnavData,
      currCard
    };
  }
);
